"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBadgeStyle = exports.createBadgeSpacingStyle = void 0;
var react_1 = require("@emotion/react");
var createBadgeSpacingStyle = function (props) {
    if ('avatarUrl' in props && props.avatarUrl) {
        return react_1.css({ padding: '2px 8px 2px 3px', gap: 4 });
    }
    if ('dot' in props && props.dot) {
        return react_1.css({ padding: '2px 8px 2px 6px', gap: 6 });
    }
    if ('icon' in props && props.icon) {
        if (props.children) {
            return react_1.css({ padding: '2px 8px 2px 6px', gap: 4 });
        }
        // Icon Only;
        return react_1.css({ padding: 5 });
    }
    return react_1.css({ padding: '2px 8px' });
};
exports.createBadgeSpacingStyle = createBadgeSpacingStyle;
var createBadgeStyle = function (backgroundColor, color) {
    return react_1.css({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 16,
        overflow: 'hidden',
        backgroundColor: backgroundColor,
        position: 'relative',
        color: color ? color : 'white',
        textAlign: 'center',
    });
};
exports.createBadgeStyle = createBadgeStyle;
